<div class="p-payment-method-finance__item">
  <span class="u-visually-hidden" [innerHTML]="'label.payeasy' | staticMsg"></span>
  <h3
    class="p-payment-method-finance__item-title p-payment-method-finance__item-title--m p-sub-column-layout01__list-item"
    [innerHTML]="'label.explanationPayeasyTitle' | staticMsg"
  ></h3>
  <p class="p-payment-method-finance__item-contents" [innerHTML]="'label.explanationPayeasyValue' | staticMsg"></p>
</div>
